// extracted by mini-css-extract-plugin
export default {"desktopMinWidth":"768","fontFamily":"\"Source Sans 3\",sans-serif"};